import { render, staticRenderFns } from "./FloatVideo.vue?vue&type=template&id=03bb0c0c"
import script from "./FloatVideo.vue?vue&type=script&lang=js"
export * from "./FloatVideo.vue?vue&type=script&lang=js"
import style0 from "./FloatVideo.vue?vue&type=style&index=0&id=03bb0c0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports